import { useState } from "react";

import { ToggleButtons } from "../../../../components/ToggleButtons";
import { useModal } from "../../../../hooks/useModal";
import { BillingPaymentPeriod } from "../../../../types/billings";
import { getStringFromISOString } from "../../../../utils/dateHandler";
import { BillingPaymentChangeModal } from "../BillingPaymentChangeModal";

interface BillingPaymentButtonsProps {
  paymentDate: string | null;
  period: BillingPaymentPeriod;
  isDisabled?: boolean;
}

export const BillingPaymentButtons = ({ paymentDate, isDisabled = false, period }: BillingPaymentButtonsProps) => {
  const { isModalVisible, toggleModalVisibility } = useModal();
  const [pendingIsPaidValue, setPendingIsPaidValue] = useState<boolean | null>(null);
  const isPaid = !!paymentDate;

  const handleIsPaidChange = (nextIsPaid: boolean) => {
    if (nextIsPaid === isPaid) return;
    setPendingIsPaidValue(nextIsPaid);
    toggleModalVisibility();
  };

  const handleModalClose = () => {
    toggleModalVisibility();
    setPendingIsPaidValue(null);
  };

  return (
    <>
      <ToggleButtons
        value={isPaid}
        trueExtraText={paymentDate ? getStringFromISOString(paymentDate) : undefined}
        isDisabled={isDisabled}
        onChange={handleIsPaidChange}
      />
      <BillingPaymentChangeModal
        isPaid={!!pendingIsPaidValue}
        period={period}
        isModalVisible={isModalVisible}
        toggleModalVisibility={handleModalClose}
      />
    </>
  );
};
